<template>
  <div class="mobilum-page">
    <Loader v-if="!widgetReady && !isError" />
    <div
      v-if="apiKey"
      id="mobilum-widget"
      :data-apikey="apiKey"
      :jwt-token="jwtToken">
      <div id="userUUid" style="display:none"></div>
      <div id="additionalData" style="display:none">{{ additionalData }}</div>
      <div id="fiatCurrency" style="display:none">{{ fiatCurrency }}</div>
      <div id="fiatAmount" style="display:none">{{ fiatAmount }}</div>
      <div id="widgetUuid" style="display:none">{{ widgetUuid }}</div>
    </div>
    <div v-if="isError" class="mobilum-page-stub">
      <h2 class="mobilum-page-stub__title">Oops!</h2>
      <p class="mobilum-page-stub__text">Something went wrong.</p>
      <p class="mobilum-page-stub__text">Please try again or contact our support team.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from './components/Loader.vue';

export default {
  components: { Loader },

  async mounted() {
    await this.$nextTick();
    await this.loadResources();
  },

  data() {
    return {
      widgetReady: false,
      isError: false,
    };
  },

  computed: {
    ...mapState(['paymentInvoiceData', 'flowData']),

    requisites() {
      const { requisites } = this.flowData?.payload || {};

      if (!requisites) return {};
      if (typeof requisites === 'string') {
        try {
          return JSON.parse(requisites);
        } catch (e) {
          return {};
        }
      }

      return requisites;
    },

    testMode() {
      return this.paymentInvoiceData?.data?.test_mode || false;
    },

    apiKey() {
      return this.requisites.api_key || '';
    },

    jwtToken() {
      return this.requisites.jwt_token || '';
    },

    widgetUuid() {
      return this.requisites.widget_uuid || '';
    },

    additionalData() {
      return this.requisites.additional_data || '';
    },

    fiatCurrency() {
      return this.requisites.fiat_currency || '';
    },

    fiatAmount() {
      return this.requisites.fiat_amount || '';
    },

    cssUrl() {
      return this.requisites.css_url || '';
    },
  },

  methods: {
    async loadResources() {
      this.ensureWidgetStyleTag();
      this.loadCss(this.cssUrl);

      const script = this.testMode ? MobilumTest : MobilumProd;

      if (this.hasScriptInBody(script)) {
        this.widgetReady = true;
        return;
      }

      const scriptTag = document.createElement('script');
      scriptTag.src = script;
      scriptTag.onload = () => {
        this.widgetReady = true;
      };
      scriptTag.onerror = e => {
        console.error(e);
        this.isError = true;
      };
      document.body.appendChild(scriptTag);
    },

    ensureWidgetStyleTag() {
      if (document.getElementById('mobilum-widget-css')) return;

      const style = document.createElement('style');
      style.id = 'mobilum-widget-css';
      document.head.appendChild(style);
    },

    loadCss(url) {
      if (!url || document.querySelector(`link[href="${url}"]`)) return;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    },

    hasScriptInBody(src) {
      return !!document.querySelectorAll(`[src="${src}"]`).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobilum-page {
  display: flex;
  justify-content: center;
  align-items: center;

  &-stub {
    &__title {
      margin: 0 0 5px;
    }

    &__text {
      margin: 0;
    }
  }
}
</style>
